import {createSlice} from '@reduxjs/toolkit'
import {IHomePageCard} from 'models/CMS'

interface IProps {
 status: string
 data: IHomePageCard[] | null
}

const initialState: IProps = {
 status: 'idle',
 data: null,
}

const homePageCardSlice = createSlice({
 name: 'homePageCard',
 initialState,
 reducers: {
  setHomePageCardData: (homePageCard, data) => {
   homePageCard.status = 'Success'
   homePageCard.data = data.payload
  },
 },
})

export const {setHomePageCardData} =
 homePageCardSlice.actions
export default homePageCardSlice.reducer
